module.exports = __webpack_public_path__ + "static/media/pet0.10f7f461.png";